module.exports = __webpack_public_path__ + "img/BMB_2019_ANIMATED.84c43f4d.svg";